const commonConfig = {
  docsUrl: 'https://pages.git.target.com/mobile-apps/bullflight-ui/#/',
  repoUrl: 'https://git.target.com/mobile-apps/bullflight-ui',
  defaultAppIcon:
    'https://tgtstorage.global.tgt-pe-prod.gcp.cloud.target.com/bullflight/images/yourapp.png',
}

export default commonConfig
